<template>
  <section>
    <h4 class="form-card-header">{{ $t('registration.home-address') }}</h4>
    <div class="form-card-form">
      <div>
        <label for="pi_country" class="block text-sm font-medium text-gray-700">{{ $t('registration.country') }}:<span class="text-danger">*</span></label>
        <select id="pi_country"
                name="nationaly"
                v-model="v$.form.country.$model"
                @blur="v$.form.country.$touch()"
                class="form-select" :disabled="danState">
          <option v-for="(item, index) in Nationality" :key="index" :value="item.key">{{ __("000_const.nationaly." + item.value) }}</option>
        </select>
        <input v-if="danState" v-model="v$.form.country.$model"
               id="pi_country"
               name="nationaly" style="display: none"/>
        <div class="error-message" v-show="v$.form.country.$errors.length">
          <div v-show="!v$.form.country.$errors.required">{{ $t('helper.please-fill') }}</div>
        </div>
      </div>

      <div>
        <label for="pi_city" class="block text-sm font-medium text-gray-700">{{ $t('registration.city') }}:<span class="text-danger">*</span></label>
        <select v-if="form.country === '496'"
                id="pi_city"
                name="city"
                v-model="v$.form.city.$model"
                @blur="v$.form.city.$touch()"
                class="form-select dropdown-color" :disabled="danState">
          <option v-for="item in cities" :key="item.id" :value="item.label">{{ item.label }}</option>
        </select>
        <input v-else
               id="pi_city"
               name="city"
               size="sm"
               class="pi-input"
               v-model="v$.form.city.$model"
               type="text"
               @blur="v$.form.city.$touch()" />
        <input v-if="danState" v-model="v$.form.city.$model"
               id="pi_city"
               name="city" style="display: none"/>
        <div class="error-message" v-show="v$.form.city.$errors.length">
          <div v-show="!v$.form.city.$errors.required">{{ $t('helper.please-fill') }}</div>
        </div>
      </div>

      <div>
        <label for="pi_district" class="block text-sm font-medium text-gray-700">{{ $t('registration.district') }}:<span class="text-danger">*</span></label>
        <select v-if="form.country === '496'"
                id="pi_district"
                name="district"
                v-model="v$.form.district.$model"
                @blur="v$.form.district.$touch()"
                class="form-select dropdown-color" :disabled="danState">
          <option v-for="item in districts" :key="item.id" :value="item.label">{{ item.label }}</option>
        </select>
        <input v-else
               id="pi_district"
               name="district"
               size="sm"
               class="pi-input"
               v-model="v$.form.district.$model"
               type="text"
               @blur="v$.form.district.$touch()" />
        <input v-if="danState" v-model="v$.form.district.$model"
               id="pi_district"
               name="district" style="display: none"/>
        <div class="error-message" v-show="v$.form.district.$errors.length">
          <div v-show="!v$.form.district.$errors.required">{{ $t('helper.please-fill') }}</div>
        </div>
      </div>

      <div>
        <label for="pi_commission" class="block text-sm font-medium text-gray-700">{{ $t('registration.commission') }}:<span class="text-danger">*</span></label>
        <select v-if="form.country === '496'"
                id="pi_commission"
                name="street"
                v-model="v$.form.commission.$model"
                @blur="v$.form.commission.$touch()"
                class="form-select dropdown-color">
          <option v-for="item in commissions" :key="item.id" :value="item.label">{{ item.label }}</option>
        </select>
        <input v-else
               id="pi_commission"
               name="street"
               size="sm"
               class="pi-input"
               v-model="v$.form.commission.$model"
               type="text"
               @blur="v$.form.commission.$touch()" />
        <input v-if="danState" v-model="v$.form.commission.$model"
               id="pi_commission"
               name="street" style="display: none"/>
        <div class="error-message" v-show="v$.form.commission.$errors.length">
          <div v-show="!v$.form.commission.$errors.required">{{ $t('helper.please-fill') }}</div>
        </div>
      </div>

      <div>
        <label for="pi_apartment" class="block text-sm font-medium text-gray-700">{{ $t('registration.apartment') }}:<span class="text-danger">*</span></label>
        <input id="pi_apartment"
               name="apartmentnumber"
               size="sm"
               class="pi-input"
               v-model="v$.form.apartment.$model"
               type="text"
               @blur="v$.form.apartment.$touch()" :readonly="danState"/>
        <div class="error-message" v-show="v$.form.apartment.$errors.length">
          <div v-show="!v$.form.apartment.$errors.required">{{ $t('helper.please-fill') }}</div>
        </div>
      </div>

      <div>
        <label for="pi_apartment_type" class="block text-sm font-medium text-gray-700">{{ $t('registration.apartment-type') }}:<span class="text-danger">*</span></label>
        <select id="pi_apartment_type"
                name="statusofaddress"
                v-model="v$.form.apartmentType.$model"
                @blur="v$.form.apartmentType.$touch()"
                class="form-select dropdown-color">
          <option v-for="(item, index) in statusofaddress" :key="index" :value="index">{{ __("000_const." + item) }}</option>
        </select>
        <div class="error-message" v-show="v$.form.apartmentType.$errors.length">
          <div v-show="!v$.form.apartmentType.$errors.required">{{ $t('helper.please-fill') }}</div>
        </div>
      </div>

      <section class="sub-step-buttons-container">
        <ic-button size="tn" type="button" color="grey" @click="previous()" class="d-flex align-items-center mr-3"><i class="sr sr-chevron-left"></i>{{ $t('button.previous') }}</ic-button>
        <ic-button size="tn" type="button" variant="success"  @click="next()" class="d-flex align-items-center ml-3">{{ $t('button.next') }} <i class="sr sr-chevron-right"></i></ic-button>
      </section>
    </div>
  </section>
</template>

<script>
import useVuelidate from '@vuelidate/core'
import { required } from '@vuelidate/validators'
import { Cities, Commissions, Countries, Districts } from '../../utils/constants'
import { MongolianCyrillicSort } from '../../utils/functions'
import { Nationality } from "../../constants"
import {mapState} from "vuex";

export default {
  setup() {
    return { v$: useVuelidate() }
  },
  props: {
    statusofaddress: {
      type: Object,
    },
  },
  data() {
    return {
      // countries: Countries.map(item => ({ id: item.num_code, label: item.name })),
      Nationality,
      cities: Cities.map(item => ({ id: item.code, label: item.name })),
      chosenCity: null,
      chosenDistrict: null,
      form: {
        country: '496',
        city: null,
        district: null,
        commission: null,
        apartment: null,
        apartmentType: null,
      }
    }
  },
  validations() {
    return {
      form: {
        country: { required },
        city: { required },
        district: { required },
        commission: { required },
        apartment: { required },
        apartmentType: { required },
      }
    }
  },
  mounted() {
    if(this.danState === true){
      this.form.city = this.tempUser.city;
      this.form.district = this.tempUser.district;
      this.form.commission = this.tempUser.street;
      this.form.apartment = this.tempUser.apartmentnumber;
    }
    this.fillOldData()
  },
  computed: {
    districts() {
      if (this.form.city) {
        return Districts.filter((dist) => dist.code.slice(0, 2) === this.chosenCity.id).map(
          (item) => {
            item.value = item.code
            item.label = item.name
            return item
          }
        )
      }
      return Districts.sort((a, b) => { return MongolianCyrillicSort(a.name, b.name) })
    },
    commissions() {
      if (this.form.city && this.form.district) {
        return Commissions.filter(
          (comm) => comm.code.slice(0, 5) === this.chosenDistrict.code
        ).map((item) => {
          item.value = item.code
          item.label = item.name
          return item
        })
      }
      return Commissions.sort((a, b) => {
        return parseInt(a.name)-parseInt(b.name)
      })
    },
    city() {
      return this.form.city
    },
    district() {
      return this.form.district
    },
    ...mapState('user', ['danState', 'tempUser']),
  },
  methods: {
    previous() {
      this.$emit('previous')
      window.scrollTo({top: 0, behavior: 'smooth'});
    },
    async next() {
      await this.v$.$validate()
      if (!this.v$.$error) {
        this.$emit('next', this.form)
      } else {
        alert(`${ this.$('helper.please-fill-required-fields') }`)
      }
      window.scrollTo({top: 0, behavior: 'smooth'});
    },
    fillOldData() {
      if (!window.oldInputs) return;
      if (window.oldInputs['district']) {
        this.$set(this.form, 'district', window.oldInputs['district']);
      }
      if (window.oldInputs['street']) {
        this.$set(this.form, 'street', window.oldInputs['street']);
      }
      if (window.oldInputs['apartmentnumber']) {
        this.$set(this.form, 'apartmentnumber', window.oldInputs['apartmentnumber']);
      }
      if (window.oldInputs['nationaly']) {
        this.$set(this.form, 'nationaly', window.oldInputs['nationaly']);
      }
      if (window.oldInputs['statusofaddress']) {
        this.$set(this.form, 'statusofaddress', window.oldInputs['statusofaddress']);
      }
    }
  },
  watch: {
    city() {
      this.chosenCity = this.cities.find((item) => item.label === this.form.city)
    },
    district() {
      this.chosenDistrict = this.districts.find((item) => item.label === this.form.district)
    }
  }
}
</script>